<div class="content-container">
  <h1>{{'login.appTitle' | translate}}</h1>
  <div>{{'login.appDescription' | translate}}</div>
  <div>
    <button mat-flat-button class="primary-button login-button" (click)="navigateToLogin()">
      {{'login.login' | translate}}
    </button>
  </div>
</div>
